(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('cgbusyService', cgbusyService);

    function cgbusyService($rootScope) {

        $rootScope.dataPromises = [];

        var service = {
                blockUI: blockUI
        };

        return service;

                
        function blockUI(promise) {
            var filtered = $rootScope.dataPromises.filter(isNotFulfilled);

            filtered.push(promise);

            $rootScope.dataPromises = filtered;
            $rootScope.$broadcast('dataPromisesChanged');
            //Return the promise so we can chain
            return promise;
        }

        function isNotFulfilled(value) {
            return !value.$cgBusyFulfilled;
        }
    }
})();